polycalc = function() {
    var length = parseFloat(document.getElementById('polycalc-length').value);
    var width = parseFloat(document.getElementById('polycalc-width').value);
    var height = parseFloat(document.getElementById('polycalc-height').value);
    
    var multi = 1;
    var to_cm = document.getElementById('to_cm').checked;
    
    var width_pad = 0.25;
    var length_pad = 0.25;
    
    
    if(to_cm){
      length = length * 2.54; 
      width = width * 2.54;
      height = height * 2.54;
      width_pad = width_pad * 2.54;
      length_pad = length_pad * 2.54;
    }
  
    var poly_length = (length + (height * 2) + length_pad).toFixed(1);
    var poly_width = (width + height + width_pad).toFixed(1);
    
    if(isNaN(poly_length)){
        poly_length = "_";
      poly_width = "_";
    }
  
    document.getElementById('result-length').innerHTML = poly_length;
    document.getElementById('result-width').innerHTML = poly_width;
  }
  
  function change_mesure(){
    if (document.getElementById('to_cm').checked) 
    {
      var mesure = document.querySelectorAll('.result__calc .mesure');
      mesure.forEach(function(m) { m.textContent="cm"; });
      var mesure = document.querySelectorAll('.calc__mesure');
      mesure.forEach(function(m) { m.textContent="cm"; });
      
    } else {
      var mesure = document.querySelectorAll('.result__calc .mesure');
      mesure.forEach(function(m) { m.textContent='"'; });  
      var mesure = document.querySelectorAll('.calc__mesure');
      mesure.forEach(function(m) { m.textContent="inches"; });
    }
    polycalc();
  }